<template>
  <div>
    <Breadcrumb msg1="处方管理" msg2="电子处方" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="5">
          <el-select v-model="query.customer_id" filterable remote placeholder="按客户搜索" :remote-method="searchCustomer" clearable style="width: 100%">
            <el-option v-for="c in customerOptions" :key="c.id" :label="c.name + ' ' + c.phone" :value="c.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4"><el-input v-model="query.prescription_no" placeholder="处方号" clearable></el-input></el-col>
        <el-col :span="4">
          <el-select v-model="query.prescription_type" placeholder="类型" clearable>
            <el-option label="配镜处方" value="配镜处方"></el-option>
            <el-option label="用药处方" value="用药处方"></el-option>
            <el-option label="检查单" value="检查单"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="query.status" placeholder="状态" clearable>
            <el-option label="有效" value="有效"></el-option>
            <el-option label="已作废" value="已作废"></el-option>
          </el-select>
        </el-col>
        <el-col :span="5">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
          <el-button type="success" icon="el-icon-plus" @click="add">开具处方</el-button>
        </el-col>
      </el-row>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" width="60"></el-table-column>
        <el-table-column label="处方号" prop="prescriptionNo" width="140"></el-table-column>
        <el-table-column label="客户" width="100"><template slot-scope="scope">{{ customerName(scope.row.customerId) }}</template></el-table-column>
        <el-table-column label="类型" prop="prescriptionType" width="100"></el-table-column>
        <el-table-column label="诊断" prop="diagnosis" show-overflow-tooltip></el-table-column>
        <el-table-column label="开具日期" prop="issueDate" width="110"></el-table-column>
        <el-table-column label="有效期(天)" prop="validDays" width="90"></el-table-column>
        <el-table-column label="状态" width="90">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '已作废' ? 'danger' : 'success'">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="view(scope.row.id)">详情</el-button>
            <el-button size="mini" type="primary" v-if="scope.row.status !== '已作废'" @click="edit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" v-if="scope.row.status !== '已作废'" @click="voidRow(scope.row)">作废</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="show" width="900px" :close-on-click-modal="false">
      <el-form :model="form" label-width="100px" v-if="show">
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户" required>
              <el-select v-model="form.customer_id" filterable remote placeholder="输入姓名/手机号搜索" :remote-method="searchCustomer" style="width: 100%">
                <el-option v-for="c in customerOptions" :key="c.id" :label="c.name + ' ' + c.phone" :value="c.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="医生">
              <el-select v-model="form.doctor_id" style="width: 100%">
                <el-option v-for="doc in doctors" :key="doc.id" :label="doc.realname" :value="doc.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="处方类型">
              <el-select v-model="form.prescription_type" style="width: 100%">
                <el-option label="配镜处方" value="配镜处方"></el-option>
                <el-option label="用药处方" value="用药处方"></el-option>
                <el-option label="检查单" value="检查单"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"><el-form-item label="开具日期"><el-date-picker v-model="form.issue_date" type="date" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="有效期(天)"><el-input v-model="form.valid_days" type="number"></el-input></el-form-item></el-col>
          <el-col :span="12"><el-form-item label="签名"><el-input v-model="form.signature"></el-input></el-form-item></el-col>
          <el-col :span="24"><el-form-item label="诊断"><el-input v-model="form.diagnosis"></el-input></el-form-item></el-col>
        </el-row>
      </el-form>
      <el-divider content-position="left">处方明细</el-divider>
      <el-table :data="form.items" border size="small">
        <el-table-column label="类型" width="110">
          <template slot-scope="scope">
            <el-select v-model="scope.row.itemType" size="mini">
              <el-option label="镜片" value="镜片"></el-option>
              <el-option label="镜架" value="镜架"></el-option>
              <el-option label="药品" value="药品"></el-option>
              <el-option label="项目" value="项目"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="名称">
          <template slot-scope="scope"><el-input v-model="scope.row.itemName" size="mini"></el-input></template>
        </el-table-column>
        <el-table-column label="规格" width="120">
          <template slot-scope="scope"><el-input v-model="scope.row.spec" size="mini"></el-input></template>
        </el-table-column>
        <el-table-column label="数量" width="80">
          <template slot-scope="scope"><el-input v-model.number="scope.row.quantity" size="mini" @change="calcAmount(scope.row)"></el-input></template>
        </el-table-column>
        <el-table-column label="单位" width="70">
          <template slot-scope="scope"><el-input v-model="scope.row.unit" size="mini"></el-input></template>
        </el-table-column>
        <el-table-column label="用法" width="110">
          <template slot-scope="scope"><el-input v-model="scope.row.usage" size="mini"></el-input></template>
        </el-table-column>
        <el-table-column label="单价" width="90">
          <template slot-scope="scope"><el-input v-model.number="scope.row.price" size="mini" @change="calcAmount(scope.row)"></el-input></template>
        </el-table-column>
        <el-table-column label="金额" width="90">
          <template slot-scope="scope">{{ scope.row.amount }}</template>
        </el-table-column>
        <el-table-column label="操作" width="70">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="removeItem(scope.$index)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button size="mini" icon="el-icon-plus" style="margin-top: 8px" @click="addItem">添加明细</el-button>
      <span slot="footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="save">保存处方</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import { loadCustomerMap, customerName } from '@/utils/customerName'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, customer_id: null, prescription_no: '', prescription_type: '', status: '' },
      list: [],
      total: 0,
      show: false,
      dialogTitle: '',
      form: { items: [] },
      customerOptions: [],
      doctors: []
    }
  },
  created () {
    this.getData()
    loadCustomerMap(this.$axios.http)
    this.$axios.http.get('/users/doctors').then(r => { if (r.data.status === 200) this.doctors = r.data.data || [] })
  },
  methods: {
    customerName,
    getData () {
      this.$axios.get('/prescriptions', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    searchCustomer (kw) {
      if (!kw) return
      this.$axios.http.get('/customers/select', { params: { keyword: kw } }).then(r => {
        if (r.data.status === 200) this.customerOptions = r.data.data || []
      })
    },
    addItem () {
      this.form.items.push({ itemType: '镜片', itemName: '', spec: '', quantity: 1, unit: '', usage: '', frequency: '', days: 0, price: 0, amount: 0 })
    },
    removeItem (i) { this.form.items.splice(i, 1) },
    calcAmount (row) {
      row.amount = ((row.quantity || 0) * (row.price || 0)).toFixed(2)
    },
    add () {
      this.dialogTitle = '开具处方'
      this.form = { customer_id: null, doctor_id: null, prescription_type: '配镜处方', diagnosis: '', issue_date: '', valid_days: 365, signature: '', remark: '', items: [] }
      this.addItem()
      this.show = true
    },
    edit (row) {
      this.dialogTitle = '编辑处方'
      this.$axios.http.get(`/prescriptions/${row.id}`).then(r => {
        if (r.data.status === 200) {
          const data = r.data.data
          const pres = data.prescription || row
          this.form = {
            id: pres.id,
            customer_id: pres.customerId,
            doctor_id: pres.doctorId,
            prescription_type: pres.prescriptionType,
            diagnosis: pres.diagnosis,
            issue_date: pres.issueDate,
            valid_days: pres.validDays,
            signature: pres.signature,
            remark: pres.remark,
            items: (data.items || []).map(it => ({
              id: it.id, itemType: it.itemType, itemName: it.itemName, spec: it.spec,
              quantity: it.quantity, unit: it.unit, usage: it.usage, frequency: it.frequency,
              days: it.days, price: it.price, amount: it.amount
            }))
          }
          this.customerOptions = [{ id: row.customerId, name: customerName(row.customerId), phone: '' }]
          this.show = true
        }
      })
    },
    save () {
      if (!this.form.customer_id) { this.$message.warning('请选择客户'); return }
      if (this.form.items.length === 0) { this.$message.warning('请至少添加一条明细'); return }
      if (this.form.id) {
        this.$axios.put(`/prescriptions/${this.form.id}`, () => { this.show = false; this.getData() }, this.form)
      } else {
        this.$axios.post('/prescriptions', () => { this.show = false; this.getData() }, this.form)
      }
    },
    voidRow (row) {
      this.$prompt('请输入作废原因', '作废处方', { inputPattern: /\S+/, inputErrorMessage: '原因不能为空' }).then(({ value }) => {
        this.$axios.put(`/prescriptions/${row.id}/void`, () => this.getData(), { reason: value })
      }).catch(() => {})
    },
    view (id) {
      this.$router.push(`/prescription/detail/${id}`)
    }
  }
}
</script>
